'use client';
import { TabPanel, TabView, type TabViewProps } from 'primereact/tabview';
import type { ReactNode } from 'react';
import styles from './tabs.module.css';

type TabProps = {
	tabName?: string;
	tabContent?: ReactNode;
};

interface TabViewContainerProps extends TabViewProps {
	tabList: Array<TabProps>;
}

const TabViewContainer = ({ tabList, ...rest }: TabViewContainerProps) => {
	return (
		<TabView
			pt={{
				nav: {
					className: styles.tabViewNavUl,
				},
				inkbar: { className: styles.tabInkBar },
				panelContainer: {
					className: styles.tabPanelBody,
				},
			}}
			{...rest}
		>
			{tabList.map((item, index) => (
				<TabPanel
					key={`tab ${index.toString()}`}
					pt={{
						headerAction: {
							className: styles.tabViewNavLink,
						},
						header: {
							className: styles.tabViewNavLi,
						},
					}}
					header={item.tabName}
				>
					{item.tabContent}
				</TabPanel>
			))}
		</TabView>
	);
};

export default TabViewContainer;
